<template>
<DIV
  class="container ml-0 mr-auto"
>
  <ItpWidgetCard>
    <ItpBox
      alignItems="center"
      slot="header"
    >
      <strong>
        {{ 'Meter Consumptions'|pgettext('MeterConsumptions') }}
      </strong>
      <ItpButton
        :text="'Add consumption...'|pgettext('MeterConsumptions')"
        variant="light"
        size="sm"
        class="ml-auto"
        @click.prevent.stop="evh_8320016629450276_clickPreventStop($event, {})"
      >
      </ItpButton>
    </ItpBox>
    <BListGroup
      v-if="loaded"
    >
      <BListGroupItem
        v-if="!items.length"
      >
        <span>
          {{ 'No consumptions.'|pgettext('MeterConsumptions') }}
        </span>
      </BListGroupItem>
      <BListGroupItem
        :key="item.id"
        class="d-flex flex-column"
        v-for="item in items"
      >
        <ItpBox
          alignItems="start"
        >
          <ItpBox
            direction="column"
            class="w-100"
          >
            <ItpBox
              class="W-100"
            >
              <ItpBox
                direction="column"
                class="col-md-2"
              >
                <strong>
                  {{ item.start.date|date }}
                </strong>
                <small>
                  {{ item.start.reading|number }} {{ item.unit }}
                </small>
              </ItpBox>
              <ItpBox
                direction="column"
                class="col-md-2"
              >
                <strong>
                  {{ item.end.date|date }}
                </strong>
                <small>
                  {{ item.end.reading|number }} {{ item.unit }}
                </small>
              </ItpBox>
              <ItpBox
                direction="column"
                class="col-md-2"
              >
                <strong>
                  {{ item.total_consumption|number }} {{ item.unit }}
                </strong>
              </ItpBox>
              <ItpBox
                alignItems="center"
                direction="column"
                class="col-md-2"
              >
                <ItpBadge
                  :title="'Billing factor'|gettext"
                  no-box-shadow
                  variant="light"
                  class="mx-3"
                  v-if="item.billing_factor"
                >
                  <ItpIcon
                    name="fa-times"
                  >
                  </ItpIcon>
                  <ItpText
                    :text="item.billing_factor"
                  >
                  </ItpText>
                </ItpBadge>
                <ItpBadge
                  variant="warning"
                  :text="'Non billable'|pgettext('RentalService')"
                  no-box-shadow
                  class="mx-3 mt-2"
                  v-if="item.non_billable"
                >
                </ItpBadge>
              </ItpBox>
              <ItpBox
                alignItems="start"
                wrap-items
                class="col-md-2"
                v-if="item.meter"
              >
                <UcCompactMeterDisplay
                  :payload="item.meter"
                  class="pl-3"
                >
                </UcCompactMeterDisplay>
              </ItpBox>
              <ItpBox
                direction="column"
                alignItems="start"
                wrap-items
                class="col-md-2"
              >
                <UcCompactCompanyDisplay
                  :payload="item.consumer"
                  class="pl-3"
                  v-if="item.consumer"
                >
                </UcCompactCompanyDisplay>
                <UcCompactRentalDisplay
                  :payload="item.rental"
                  class="pl-3"
                >
                </UcCompactRentalDisplay>
              </ItpBox>
            </ItpBox>
            <ItpBox>
              <div
                class="col-md-7"
              >
                <ItpText
                  :text="item.note"
                  pre
                  v-if="item.note"
                >
                </ItpText>
              </div>
            </ItpBox>
          </ItpBox>
          <ItpButton
            icon="fa-pen"
            :tooltip="'Edit'|gettext"
            variant="light"
            size="sm"
            class="ml-auto"
            @click.prevent.stop="evh_8497951412896552_clickPreventStop($event, {item})"
          >
          </ItpButton>
        </ItpBox>
      </BListGroupItem>
    </BListGroup>
  </ItpWidgetCard>
</DIV>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcMeterConsumptions extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  meter!: object;

  @Watch('meter')
  onMeter(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("meter")
  }

  items!: any;

  async $$load_items() {
    return this.meter.consumptions
      ? this.meter.consumptions.data
      : this.$fn.fetch('list_meter_consumptions', { parameters: { meter_id: this.meter.id } })
  }

  ux!: any;
  dataMembers = ['items', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        items: null,
        ux: null,
      },
    }
  }

  async act_8320016629450276_emit_9448_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_8320016629450276_emit_9448, alias=emitReload
    return {
      event: "reload",
    }
  }

  async evh_8320016629450276_close_9447_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_8320016629450276_close_9447, alias=undefined
    return !!$event.data.modalResult.ok
  }

  async act_8320016629450276_showModal_9446_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_8320016629450276_showModal_9446, alias=undefined
    return {
      name: "MeterConsumption",
      props: {
        meter: this.meter,
      }
      ,
    }
  }

  async evh_8320016629450276_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_8497951412896552_emit_9452_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_8497951412896552_emit_9452, alias=emitReload
    return {
      event: "reload",
    }
  }

  async evh_8497951412896552_close_9451_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_8497951412896552_close_9451, alias=undefined
    return !!$event.data.modalResult.ok
  }

  async act_8497951412896552_showModal_9450_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_8497951412896552_showModal_9450, alias=undefined
    return {
      name: "MeterConsumption",
      props: {
        oid: $event.scope.item.id,
        meter: this.meter,
      }
      ,
    }
  }

  async evh_8497951412896552_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8497951412896552_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_8320016629450276_emit_9448: actions.EmitAction;
    evh_8320016629450276_close_9447: actions.EventHandlerImpl;
    act_8320016629450276_showModal_9446: actions.ShowModalAction;
    evh_8320016629450276_clickPreventStop_9445: actions.EventHandlerImpl;
    evh_8320016629450276_clickPreventStop: actions.EventHandlerGroup;
    act_8497951412896552_emit_9452: actions.EmitAction;
    evh_8497951412896552_close_9451: actions.EventHandlerImpl;
    act_8497951412896552_showModal_9450: actions.ShowModalAction;
    evh_8497951412896552_clickPreventStop_9449: actions.EventHandlerImpl;
    evh_8497951412896552_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_8320016629450276_emit_9448 = new actions.EmitAction(
      {
        actionArgs: this.act_8320016629450276_emit_9448_getActionArgs,
        displayName: "emitReload",
        events: [],
      }
    );
    const evh_8320016629450276_close_9447 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_emit_9448,
        event: "close",
        when: this.evh_8320016629450276_close_9447_getWhen,
        displayName: "emitReload",
      }
    );
    const act_8320016629450276_showModal_9446 = new actions.ShowModalAction(
      {
        actionArgs: this.act_8320016629450276_showModal_9446_getActionArgs,
        events: [evh_8320016629450276_close_9447],
      }
    );
    const evh_8320016629450276_clickPreventStop_9445 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_showModal_9446,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_8320016629450276_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_8320016629450276_clickPreventStop_9445],
      }
    );
    const act_8497951412896552_emit_9452 = new actions.EmitAction(
      {
        actionArgs: this.act_8497951412896552_emit_9452_getActionArgs,
        displayName: "emitReload",
        events: [],
      }
    );
    const evh_8497951412896552_close_9451 = new actions.EventHandlerImpl(
      {
        action: act_8497951412896552_emit_9452,
        event: "close",
        when: this.evh_8497951412896552_close_9451_getWhen,
        displayName: "emitReload",
      }
    );
    const act_8497951412896552_showModal_9450 = new actions.ShowModalAction(
      {
        actionArgs: this.act_8497951412896552_showModal_9450_getActionArgs,
        events: [evh_8497951412896552_close_9451],
      }
    );
    const evh_8497951412896552_clickPreventStop_9449 = new actions.EventHandlerImpl(
      {
        action: act_8497951412896552_showModal_9450,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_8497951412896552_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_8497951412896552_clickPreventStop_9449],
      }
    );
    return {
      act_8320016629450276_emit_9448,
      evh_8320016629450276_close_9447,
      act_8320016629450276_showModal_9446,
      evh_8320016629450276_clickPreventStop_9445,
      evh_8320016629450276_clickPreventStop,
      act_8497951412896552_emit_9452,
      evh_8497951412896552_close_9451,
      act_8497951412896552_showModal_9450,
      evh_8497951412896552_clickPreventStop_9449,
      evh_8497951412896552_clickPreventStop,
      emitReload: act_8497951412896552_emit_9452,
    }
  }
}

Vue.component("UcMeterConsumptions", UcMeterConsumptions);

</script>